
angular.module('eCareVault.common.directives').directive('ecvUiSelectPlaceholderAlwaysVisible', function() {
    return {
        require: 'uiSelect',
        link: function($scope, $element, attrs, $select) {
            $select.getPlaceholder = function () {
                return $select.placeholder;
            }
        }
    }
});
